import PillarForm from "shared/components/pillar-form/PillarForm";
import { useHubCheckoutContext } from "hub/src/pages/checkout/context/HubCheckoutContext";

export const HubCheckoutSameAsBillingCheckbox = () => {
  const { paymentFormValues } = useHubCheckoutContext();
  return (
    <div className="flex items-center space-x-1 pb-6">
      <PillarForm.Checkbox
        name="isSameAsBilling"
        isChecked={paymentFormValues?.isSameAsBilling}
      />
      <label
        htmlFor="isSameAsBilling"
        className="text-sm font-medium text-gray-900"
      >
        Shipping address is the same as billing information
      </label>
    </div>
  );
};
